import type { Canceler } from 'axios'
import { WrappedResponse } from './core'

export const queryKeys = {
  listAccountsAndProjects: 'listAccountsAndProjects',
  getReferenceProductItems: 'getReferenceProductItems',
  getWasteCarriers: 'getWasteCarriers',
  getWasteFacilities: 'getWasteFacilities',
  getWasteContainerTypes: 'getWasteKNownContainerTypes',
  getCertificates: 'getCertificates',
  getCompanies: 'getCompanies',
  getCompany: companyId => 'getCompany/' + companyId,
  deleteCompany: companyId => 'deleteCompany/' + companyId,
  getSuppliersAndManufacturers: 'getSuppliersAndManufacturers',
  getManufacturer: companyId => 'getManufacturer/' + companyId,
  deleteManufacturer: companyId => 'deleteManufacturer/' + companyId,
  getSupplier: companyId => 'getSupplier/' + companyId,
  deleteSupplier: companyId => 'deleteSupplier/' + companyId,
  getProductGroups: 'getProductGroups',
  getApiKeys: 'getApiKeys',
  records: 'records',
  record: id => 'records/' + id,
  transferRecordToModule: 'transferRecordToModule',
  listUsers: 'listUsers',
  listUserAccountMappings: 'listUserAccountMappings',
  listBIReports: 'listBIReports',
  listBIReportsWorkspaces: 'listBIReportsWorkspaces',
  biReportsUserPermissions: accountId =>
    'biReportsUserPermissions/' + accountId,
  biReportsWorkspaceReports: workspaceId =>
    'listBiReportsWorkspaceReports/' + workspaceId,
  getUser: userId => 'getUser/' + userId,
  getUserAccountMappings: userId => 'getUserAccountMappings/' + userId,
  userSelf: 'userSelf',
  userSelfAccountMappings: 'userSelfAccountMappings',
  getSmartWasteConfig: projectId => 'getSmartWasteConfig/' + projectId,
  listQflowUsers: 'listQflowUsers',
  listSSOIDPs: 'listSsoidps'
}

export const getCancellable = () => {
  let resolve: ((value: null) => void) | null = null
  const promise = new Promise<null>(_resolve => {
    resolve = _resolve
  })

  ;(promise as any).cancel = () => resolve?.(null)

  return promise
}

export const queryify = <T>(
  promise: Promise<WrappedResponse<T>>,
  onCancel: Canceler | null = null
): Promise<T> => {
  async function wrap(): Promise<T> {
    const [data, , error] = await promise
    if (data == null) {
      throw error
    }
    return data
  }

  const dataPromise = wrap()
  if (onCancel) {
    ;(dataPromise as any).cancel = onCancel
  }

  return dataPromise
}
